/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import { makeStyles, Typography } from '@material-ui/core';

import IconCloseRound from '../../assets/images/ic-close-round.svg';
import { ReactComponent as IconTrash } from '../../assets/images/ic-trash.svg';
import LoadingButton from '../common/LoadingButton';

const useStyles = makeStyles((theme) => ({
  buttonCancel: {
    marginRight: '5px',
  },
  buttonDelete: {
    marginLeft: '5px',
  },
  buttonsContainer: {
    display: 'flex',
    width: '100%',
  },
  closeIcon: {
    cursor: 'pointer',
    height: '24px',
    width: '24px',
  },
  closeIconContainer: {
    textAlign: 'right',
    width: '100%',
  },
  container: {
    background: '#FFF',
    padding: '36px',
    width: 'auto',
    [theme.breakpoints.up('md')]: {
      width: '450px',
    },
  },
  contentContainer: {
    marginTop: '16px',
  },
  iconTrash: {
    height: '22px',
    marginRight: '10px',
    stroke: theme.palette.primary.main,
    width: '22px',
  },
  titleContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  typographyDescription: {
    color: '#172B4D',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '24px',
    marginBottom: '20px',
    marginTop: '10px',
    textAlign: 'center',
  },
  typographyExtraText: {
    color: '#999999',
    fontSize: '12px',
    lineHeight: '18px',
    marginBottom: '40px',
  },
  typographyTitle: {
    color: theme.palette.primary.main,
    fontSize: '22px',
    fontWeight: '500',
    lineHeight: '24px',
  },
}));

export default ({ onCancel, onCloseIconClick, onConfirm }) => {
  const classes = useStyles();

  const handleCloseIconClick = () => {
    if (onCloseIconClick) onCloseIconClick();
  };

  const handleCancelClick = () => {
    if (onCancel) onCancel();
  };

  const handleDeleteImagesClick = () => {
    if (onConfirm) onConfirm();
  };

  return (
    <div className={classes.container}>
      <div className={classes.closeIconContainer}>
        <img onClick={handleCloseIconClick} src={IconCloseRound} alt="close icon" className={classes.closeIcon} />
      </div>

      <div className={classes.contentContainer}>
        <div className={classes.titleContainer}>
          <IconTrash className={classes.iconTrash} />
          <Typography className={classes.typographyTitle}>Remove Images</Typography>
        </div>

        <Typography className={classes.typographyDescription} align="center">
          Are you sure you would like to remove your radiology images from your Mediphany account?
        </Typography>

        <Typography className={classes.typographyExtraText} align="center">
          This action can not be undone.
        </Typography>

        <div className={classes.buttonsContainer}>
          <LoadingButton onClick={handleCancelClick} className={classes.buttonCancel} fullWidth size="large" variant="contained" color="primary">
            Cancel
          </LoadingButton>
          <LoadingButton onClick={handleDeleteImagesClick} className={classes.buttonDelete} fullWidth size="large" variant="outlined" color="primary">
            Delete Images
          </LoadingButton>
        </div>
      </div>
    </div>
  );
};
